import useActiveOrganization from "./useActiveOrganization";
import {useCallback} from "react";
import {getPlanLimit} from "../../../util/subscription";
import useTranslation from "../../../i18n/useTranslation";

export default function useCheckLimitOrPrompt(subscriptionOverride) {
    const hasSubscriptionOverride = subscriptionOverride !== undefined;
    const {activeSubscription: resolvedSubscription} = useActiveOrganization(undefined, {
        skipQuery: hasSubscriptionOverride,
    });
    const activeSubscription = hasSubscriptionOverride ? subscriptionOverride : resolvedSubscription;
    const {t} = useTranslation();

    return useCallback(
        ({currentCount, itemLabel, toast}) => {
            const currentPlan = activeSubscription?.plan?.name || "Free";
            const planKey = (activeSubscription?.plan?.name || "free").toLowerCase();
            const limit = getPlanLimit(planKey, itemLabel);

            if (currentCount >= limit) {
                toast.warning(
                    t("subscriptionLimit.planLimit", {
                        currentPlan: currentPlan,
                        limit,
                        itemLabel: itemLabel,
                    }),
                    {
                        autoClose: 5000,
                        toastId: "subscription_restriction",
                        position: "top-center",
                        closeOnClick: true,
                    }
                );
                return false;
            }
            return true;
        },
        [activeSubscription, t]
    );
}
